module.exports = __webpack_public_path__ + "images/Shoprite-Frontf9e3bd2db7a3f80d6e12db957ba16d03.jpg";